import React from 'react'
import { formatToZMW, sumOfArray } from '../../../../helpers'

const Lgcf = ({currentYearData, previousYearData, sof, startDate}) => {

    const funding = currentYearData?.filter(a=>a.type === 'income') || []
    const fundingPreviousYear = previousYearData?.filter(a=>a.type === 'income') || []
    const currentYear = startDate ? new Date(startDate).getFullYear() : new Date().getFullYear();
    const previousYear = currentYear - 1;

    const months = ['1st Funding - January', '2nd Funding - February', '3rd Funding - March', '4th Funding - April', '5th Funding - May', '6th Funding - June', '7th Funding - July', '8th Funding - August', '9th Funding - September', '10th Funding - October', '11th Funding - November', '12th Funding - December']
    
  return (
    <div>
<hr className="border-t-2 border-slate-200 py-5" />
        <h1 className='text-2xl font-bold text-slate-800'> {sof===2?`Local Government Capital Fund`:sof===3?`Constituency Development Fund`:sof===7?`Sector Grant`:``}</h1>

        <table className='w-full table-auto border-collapse shadow-sm rounded-lg overflow-hidden'>  
                <thead className='bg-blue-950 text-white'>
                    <tr>
                        <th className='text-left px-4 py-3 w-1/2'>Funding</th>
                        <th className='text-right px-4 py-3 w-1/2'>{currentYear}</th>
                        <th className='text-right px-4 py-3 w-1/2'>{previousYear}</th>
                    </tr>
                </thead>
                <tbody className='bg-white'>
                    {
                        months.map((month, index) => {
                            const currentMonthData = funding.filter(a => new Date(a.date).getMonth() === index)
                            const previousMonthData = fundingPreviousYear.filter(a => new Date(a.date).getMonth() === index)
                            
                            const currentAmount = sumOfArray(currentMonthData.map(item => parseFloat(item.amount) || 0))
                            const previousAmount = sumOfArray(previousMonthData.map(item => parseFloat(item.amount) || 0))
                            
                            return (
                                <tr key={index} className="odd:bg-gray-50">
                                    <td className='px-4 py-3 text-slate-800 font-medium'>{month}</td>
                                    <td className='px-4 py-3 text-right font-medium text-slate-800'>{formatToZMW(currentAmount)}</td>
                                    <td className='px-4 py-3 text-right font-medium text-slate-800'>{formatToZMW(previousAmount)}</td>
                                </tr>
                            )
                        })
                    }
                    
                    {/* Totals Row */}
                    {(() => {
                        // Calculate totals across all months
                        const totalCurrentYear = months.reduce((total, month, index) => {
                            const currentMonthData = funding.filter(a => new Date(a.date).getMonth() === index)
                            const currentAmount = sumOfArray(currentMonthData.map(item => parseFloat(item.amount) || 0))
                            return total + currentAmount
                        }, 0)

                        const totalPreviousYear = months.reduce((total, month, index) => {
                            const previousMonthData = fundingPreviousYear.filter(a => new Date(a.date).getMonth() === index)
                            const previousAmount = sumOfArray(previousMonthData.map(item => parseFloat(item.amount) || 0))
                            return total + previousAmount
                        }, 0)

                        return (
                            <tr className="bg-blue-950 text-white font-bold">
                                <td className="px-4 py-3 font-bold">TOTAL</td>
                                <td className="px-4 py-3 text-right font-bold">
                                    {formatToZMW(totalCurrentYear)}
                                </td>
                                <td className="px-4 py-3 text-right font-bold">
                                    {formatToZMW(totalPreviousYear)}
                                </td>
                            </tr>
                        )
                    })()}
                </tbody>    
        </table>
    </div>
  )
}

export default Lgcf